import React, {useRef } from 'react'
import {
    Card,
    Progress
} from "@material-tailwind/react";

import { useShared } from '../../hooks/useShared';
import AIcon from '../partials/AIcon';
export default function UploadFiles({ v }) {
    const {progress, setProgress, com, consts, http } = useShared();
    const inputFile = useRef(null)

    const onFileChange = (event) => {
        const fls = event.target.files;
        console.log(v.files, "files ", fls)
        // v.setFiles(fls);
        for (let i = 0; i < fls.length; i++) {
            let existing = v.files?.some(f => f.name === fls[i].name && f.size === fls[i].size); //check duplicate files
            if (!existing) {
                v.setFiles(pre => [...pre,
                {
                    name: fls[i].name,
                    file: fls[i],
                    size: fls[i].size,
                    temp_file: window.URL.createObjectURL(fls[i])
                }])
            }
        }

        setProgress(0)
    };

    

    const handleClick = (e) => {
        e.preventDefault();
        inputFile.current.click()
    }

    const openInNewTab = (obj) => {
        console.log(obj);
        obj?.id>0? window.open(consts.BASE_URL + obj?.path): window.open( obj?.temp_file)
    }

    const removePhoto = async (i, obj) => {

        if (window.confirm("Do you want to delete it?")) {
            const copy = [...v.files]
            copy.splice(i, 1)
            v.setFiles(copy)
            inputFile.current.value = null;
            if (obj?.id && obj?.id > 0) {
                try {
                    const res = await http.post('api/remove/photo', { attachment: obj })
                    console.log("remove attachment ... ", res);
                    if (res.data.success) {
                      
                    }
                } catch (error) {
                    console.log('error photo remove ', error);
                }
            }
        }
    }


    return (
        <div className={`w-full p-2 mt-2  relative ${v.className}`}>
            <Card className={`p-3 grid  `}>
                <p className="text-sm text-main-color font-bold mb-3 border-b pb-2">Upload Attachments</p>
                <div className={` cursor-pointer relative border border-main-color 
                flex items-center justify-center bg-contain bg-no-repeat 
                h-[50px] bg-center w-full md:w-[10%] rounded-md `} onClick={handleClick} >
                    <AIcon name="add-outline" size={50} className="text-main-color " />
                </div>
                <input
                    style={{ display: 'none' }}
                    ref={inputFile}
                    type="file"
                    multiple
                    onChange={onFileChange}
                />

                {progress > 0 && <Progress color="green" value={progress} label="Completed" />}

               { v.files?.length>0  &&  <table className='gTable mt-2'>
                    <thead>
                        <tr className='!bg-deep-purple-900/20 !text-deep-purple-500'>
                            <th>#</th>
                            <th>Name</th>
                            <th>Size</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {v.files?.map((f, i) => {
                            return (
                                <tr key={f.size + i}>
                                    <td>{i + 1}</td>
                                    <td>{f.name}</td>
                                    <td>{com?.formatBytes(f.size)}</td>
                                    
                                    <td> 
                                    <AIcon onClick={(e) => openInNewTab(f)} name="eye-outline" size={20} className="text-green-700 cursor-pointer hover:text-green-500 mx-1" />
                                    <AIcon onClick={(e) => removePhoto(i, f)} name="close-circle-outline" size={20} className="text-main-color cursor-pointer hover:text-red-500" /> 
                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </table>}

            </Card>
        </div>
    )
}
